import React, { useState, useEffect } from 'react'
import { Table } from 'rsuite'
import { HEADER_CELL_WB } from '../../constants/constants'
import { budgetFormat } from '../../utils/formatterUtil'

export default function SubprojectTable({ datas, loading, ...props }) {
  const {} = props
  const { Column, HeaderCell, Cell } = Table

  const fs = localStorage.getItem('fontSize')

  return (
    <>
      <Table
        wordWrap
        // autoHeight
        height={500}
        loading={loading}
        data={datas || []}
        style={{ marginTop: '20px' }}
        headerHeight={fs <= 15 ? undefined : fs < 16 ? 45 : fs <= 18 ? 50 : 55}
      >
        <Column width={90} align="center">
          <HeaderCell style={HEADER_CELL_WB}>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={170}>
          <HeaderCell style={HEADER_CELL_WB}>รหัสโครงการย่อย</HeaderCell>
          <Cell dataKey={'code'} />
        </Column>
        <Column width={180}>
          <HeaderCell style={HEADER_CELL_WB}>เลขที่สัญญา</HeaderCell>
          <Cell dataKey={'contractNo'} />
        </Column>
        <Column width={300} minWidth={300} flexGrow={1}>
          <HeaderCell style={HEADER_CELL_WB}>ชื่อโครงการย่อย</HeaderCell>
          <Cell dataKey={'name'} />
        </Column>
        <Column width={200} align="center">
          <HeaderCell style={HEADER_CELL_WB}>สถานะโครงการย่อย</HeaderCell>
          <Cell dataKey={'status'} />
        </Column>
        <Column width={200} align="right">
          <HeaderCell style={HEADER_CELL_WB}>จำนวนเงินอนุมัติ</HeaderCell>
          <Cell>
            {(rowData, index) => {
              return budgetFormat(rowData.budget)
            }}
          </Cell>
        </Column>
        <Column width={300} align="center">
          <HeaderCell style={HEADER_CELL_WB}>วันที่เริ่มต้น -สิ้นสุดโครงการ</HeaderCell>
          <Cell>
            {(rowData, index) => {
              return `${rowData.startDate} - ${rowData.endDate}`
            }}
          </Cell>
        </Column>
        <Column width={250}>
          <HeaderCell style={HEADER_CELL_WB}>ผู้รับทุน</HeaderCell>
          <Cell dataKey={'grantee'} />
        </Column>
      </Table>
    </>
  )
}
